import React, { useState } from 'react';

import { LocalPopup } from '@interlayer/js/components/common/Popup/LocalPopup';
import { WebContent } from '@interlayer/js/components/system/WebContent/WebContent';

import { componentService } from '@core/js/services/component.service';

import { useGetWebContentData } from '@interlayer/js/app/components/system/WebContent/hooks/useGetWebContentData';
import { clsx } from '@interlayer/js/app/utils/clsx.util';

import { DYNAMIC_BANNER } from './constants';
import { TDynamicBannerProps } from './types';

import style from './DynamicBanner.scss';

export const DynamicBanner: React.FC<TDynamicBannerProps> = ({ config: { bannerUrl, webContentId, modalWebContentId } = {} }) => {
    const [isShowPopup, setIsShowPopup] = useState(false);
    const { state: { data } } = useGetWebContentData<string>({
        id: modalWebContentId
    });

    if (!bannerUrl && !webContentId) {
        return null;
    }

    const handlerShowPopup = () => {
        if (!modalWebContentId) {
            return;
        }

        setIsShowPopup(true);
    };

    return (
        <>
            {isShowPopup && (
                <LocalPopup
                    fullscreen
                    onClose={() => setIsShowPopup(false)}
                >
                    {/* @TODO remove id after implementing ts for WebContent */}

                    <WebContent content={data} id={undefined} />
                </LocalPopup>
            )}

            <div
                className={clsx(style.container, { [style.isActive]: modalWebContentId })}
                onClick={handlerShowPopup}
            >
                {bannerUrl
                    ? <img src={bannerUrl} alt="Banner" />
                    : <WebContent id={webContentId} />
                }
            </div>
        </>
    );
};

componentService.registerPageComponents({ [DYNAMIC_BANNER]: DynamicBanner });
